/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-13 13:45:41
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-06-17 10:26:26
 * @name: 琴行对象
 * @Description: 琴行对象
 * @FilePath: \preSaleNafterSaleBackstage\src\object\pianoCompany\pianoCompany.class.js
 * @Author: DESKTOP-1QU67QM
 */
import { agencyGetList, agencyAdd, accountAdd, accountEdit, accountDelete, agencySetBelong, agencySetCredit, agencyDelete, agencyGetAllList, agencyGoodsAddGoods, verify } from '@/api/pianoCompanyManage/pianoCompanyManage.api.js';
import { apiMethod } from '@/utils/decorator.js';

const pianoCompany = class pianoCompany {
  constructor() {
    this.pianoCompanyTable = { total: 0, list: [] }; //琴行表格数据
    this.pianoCompanyWaitTable = { total: 0, list: [] }; //待审核琴行表格数据
    this.salers = []; //销售数组
    this.managers = []; //销售经理数组
    this.cycles = []; //还款周期可选列表
    this.options_pianoCompany = []; //所有琴行
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 查询表格数据
   * @param {Object} params 查询参数
   * @return {Promise} resolve: 成功回调, reject: 失败回调
   */
  @apiMethod(agencyGetList)
  async getPianoCompanyTable(res) {
    if (res.code === 200) {
      this.pianoCompanyTable.total = res.data.total;
      this.pianoCompanyTable.list = res.data.data;
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 查询表格数据
   * @param {Object} params 查询参数
   * @return {Promise} resolve: 成功回调, reject: 失败回调
   */
  @apiMethod(agencyGetList)
  async getPianoCompanyWaitTable(res) {
    if (res.code === 200) {
      this.pianoCompanyWaitTable.total = res.data.total;
      this.pianoCompanyWaitTable.list = res.data.data;
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取销售数组
   * @return {Promise} resolve: 成功回调, reject: 失败回调
   */
  async getSalers() {
    return new Promise((resolve, reject) => {
      let mailList = require('@/object/mailList/mailList.class.js').default;
      new mailList().getAllPeople({ role_id: 1 }).then(res => {
        this.salers = res.data;
        resolve();
      })
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取经理数组
   * @return {Promise} resolve: 成功回调, reject: 失败回调
   */
  async getManagers() {
    return new Promise((resolve, reject) => {
      let mailList = require('@/object/mailList/mailList.class.js').default;
      new mailList().getAllPeople({ role_id: 2 }).then(res => {
        this.managers = res.data;
        resolve();
      })
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取还款周期可选列表
   * @return {Promise} resolve: 成功回调, reject: 失败回调
   */
  async getCycles() {
    return new Promise((resolve, reject) => {
      this.cycles = [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
      ]
      resolve();
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 添加琴行
   * @param {Object} obj 添加数据
   * @return {Promise} resolve: 成功回调, reject: 失败回调
   */
  @apiMethod(agencyAdd)
  async addPianoCompany(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 更换销售
   * @param {Object} obj 更换数据
   * @return {Promise} resolve: 成功回调, reject: 失败回调
   */
  @apiMethod(agencySetBelong)
  async updateSaler(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 更换经理
   * @param {Object} obj 更换数据
   * @return {Promise} resolve: 成功回调, reject: 失败回调
   */
  @apiMethod(agencySetBelong)
  async updateManager(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 添加账号
   * @param {Object} obj 添加账号数据
   * @return {Promise} resolve: 成功回调, reject: 失败回调
   */
  async addAccount(obj) {
    return new Promise((resolve, reject) => {
      resolve();
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 商品权限修改
   * @param {Object} obj 商品权限修改数据
   * @return {Promise} resolve: 成功回调, reject: 失败回调
   */
  async editJurisdiction(obj) {
    return new Promise((resolve, reject) => {
      let agency_id = obj.id;
      let goods_sku_id_level_collection = obj.arr.map(x => {
        let select = x.levels.find(y => y.id === x.select);
        return {
          goods_level_id: select?.id,
          goods_sku_id: select?.goods_sku_id,
          level: select?.level,
        }
      })
      let params = {
        agency_id,
        goods_sku_id_level_collection,
      }
      agencyGoodsAddGoods(params).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      })
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 额度设置
   * @param {Object} obj 额度设置信息
   * @return {Promise} resolve: 成功回调, reject: 失败回调
   */
  @apiMethod(agencySetCredit)
  async editLimit(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 回款周期设置
   * @param {Object} obj 还款周期信息
   * @return {Promise} resolve: 成功回调, reject: 失败回调
   */
  @apiMethod(agencySetCredit)
  async editCycle(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 删除琴行
   * @param {Number} agency_id 琴行id
   * @return {Promise} resolve: 成功回调, reject: 失败回调
   */
  @apiMethod(agencyDelete)
  async delPianoCompany(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 编辑账号
   * @param {Object} obj 提交数据
   * @return {Promise} resolve: 成功回调, reject: 失败回调
   */
  @apiMethod(accountEdit)
  async editAccount(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 添加子账号
   * @param {Object} obj 提交数据
   * @return {Promise} resolve: 成功回调, reject: 失败回调
   */
  @apiMethod(accountAdd)
  async addAccount(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 删除子账号
   * @param {Object} obj 提交数据
   * @return {Promise} resolve: 成功回调, reject: 失败回调
   */
  @apiMethod(accountDelete)
  async deleteAccount(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取琴行数组
   */
  @apiMethod(agencyGetAllList)
  async getOptionsPianoCompany(res) {
    if (res.code === 200) {
      this.options_pianoCompany = res.data;
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取琴行数组
   */
  @apiMethod(verify)
  verify(res) { }
}

export default pianoCompany;
